import { SectionLabel } from "./Reveal";

export default function PageHero({ label, title, subtitle }) {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-40 pb-20 lg:pt-48 lg:pb-28 border-b border-white/5 overflow-hidden"
    >
      <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full opacity-[0.08] blur-3xl gold-bg pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <SectionLabel testId="page-hero-label">{label}</SectionLabel>
        <h1 className="mt-7 font-serif text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight text-white max-w-4xl leading-[1.02]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-7 font-sans text-base lg:text-lg max-w-2xl text-white/60 leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
